<template>
<div class="expand-tray-container" :class="[dataClasses, closeButton ? 'has-close' : '']" >
  <div class="expand-element">
    <div class="expand-tray" v-if="!isList">
      <div v-if="dataExpand">
        <p v-html="dataExpand.fullText"></p>
        <br />
        <p v-html="dataExpand.note"></p>
      </div>
      <p v-else v-html="dataDescription"></p>
      <div v-if="dataNote">
        <br />
        <b>Note:</b>
        <p v-html="dataNote"></p>
      </div>
    </div>
    <ol class="exprand-tray-list" v-else>
      <li v-for="(text, index) in dataList" :key="index" v-html="text"></li>
    </ol>
     <button v-if="closeButton" @click="$_close()"
      class="btn-floating btn-flat waves-effect close-btn">
      <i class="material-icons grey-text text-darken-4">close</i>
       </button>
  </div>
</div>  
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'ExpandTray',
  props: {
    closeButton: {
      type: Boolean,
      default: false
    },
    dataClasses:{
      type: String,
    },
    dataExpand: {
      type: Object,
      default: null,
    },
    dataDescription: {
      type: String,
      default: '',
    },
    dataNote: {
      type: String,
      default: '',
    },
    isList: {
      type: Boolean,
      default: false,
    },
    dataList: {
      type: [Array, Object],
      default: () => {
        [];
      },
    },
  },
  data() {
    return {};
  },
  mounted() {
    this.$_setupHelpers();
  },
  computed: {},
  methods: {
    ...mapActions('Helpers', ['setHelper_']),
    $_close() {
      this.$emit('tipAction', false)
    },
    $_setupHelpers() {
      const helpers = this.$el.querySelectorAll('[helper-id]');

      if (helpers)
        helpers.forEach((helperEl) => {
          helperEl.addEventListener('click', (event) => {
            event.preventDefault();
            const helperId = helperEl.getAttribute('helper-id');
            /* this.setHelper_(helperId); */
            
            const styles = helperEl.getAttribute("helper-style")
            this.$store.dispatch("Helpers/setHelper_", {id:helperId, styles:styles ? styles : ''})
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.expand-tray-container {
  
  &.has-close {
      .expand-element { padding-top: 24px; }
  }
  .expand-element {
    position: relative;
    padding: 16px 35px;
    background: rgba(83, 116, 248, 0.05);
    /* background: rgba(0,0,0,0.09); */
  }
  &.in-list {
    margin: 0px -30px 16px;
  }
  .close-btn {
    position: absolute;
    right: 10px; 
    top: 10px;
  }
}
</style>
<style lang="scss">
 .custom-checkbox-group-field {
   .card-content {
    .expand-tray-container {
      margin: 12px -16px;
     width: calc(100% + 32px)
    }
    
    li {
    .expand-tray-container {
        margin: 12px 0 12px -56px;
        width: calc(100% + 72px)
      }
    }
   }
 }
</style>